var _style, _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIdea(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 37.8 37.9",
    style: {
      enableBackground: "new 0 0 37.8 37.9"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#002D5A;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M37.2,19.4h-2c-0.3,0-0.5-0.2-0.5-0.5s0.2-0.5,0.5-0.5h2c0.3,0,0.5,0.2,0.5,0.5S37.5,19.4,37.2,19.4z M2.5,19.4 h-2c-0.3,0-0.5-0.2-0.5-0.5s0.2-0.5,0.5-0.5h2c0.3,0,0.5,0.2,0.5,0.5S2.8,19.4,2.5,19.4z M30.5,7.8c-0.1,0-0.3,0-0.4-0.1 c-0.2-0.2-0.2-0.5,0-0.7l1.4-1.4c0.2-0.2,0.5-0.2,0.7,0s0.2,0.5,0,0.7l-1.4,1.4C30.7,7.7,30.6,7.8,30.5,7.8z M7.2,7.8 c-0.1,0-0.3,0-0.4-0.1L5.4,6.2C5.3,6.1,5.3,6,5.3,5.9s0-0.3,0.1-0.4c0.2-0.2,0.5-0.2,0.7,0l1.4,1.4C7.7,7,7.7,7.2,7.7,7.3 s0,0.3-0.1,0.4S7.3,7.8,7.2,7.8z M18.8,3.1c-0.3,0-0.5-0.2-0.5-0.5v-2c0-0.3,0.2-0.5,0.5-0.5s0.5,0.2,0.5,0.5v2 C19.3,2.9,19.1,3.1,18.8,3.1z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M18.8,37.8c-1.2,0-2.4-0.5-3.2-1.3c-0.9-0.9-1.3-2-1.3-3.2c0.2-1.1,0.1-2.2-0.3-3.1c-0.3-1-0.9-1.9-1.6-2.6 c-1.8-1.4-3.1-3.2-3.8-5.4C7.9,20,8,17.7,8.7,15.5c0.7-2.1,2.1-4,3.9-5.3c1.8-1.3,4-2,6.3-2c2.3,0,4.4,0.7,6.3,2 c1.8,1.3,3.2,3.2,3.9,5.3c0.7,2.1,0.7,4.4,0.1,6.6c-0.7,2.2-2,4-3.8,5.4c-0.7,0.7-1.2,1.6-1.6,2.6c-0.3,1-0.4,2-0.3,3.1 c0,1.3-0.5,2.4-1.3,3.3C21.2,37.3,20,37.8,18.8,37.8z M18.8,9.2c-2.1,0-4,0.6-5.7,1.8c-1.7,1.2-2.9,2.9-3.5,4.8 c-0.6,1.9-0.7,4-0.1,6c0.6,2,1.8,3.6,3.4,4.9c0,0,0,0,0.1,0c0.8,0.8,1.5,1.9,1.9,3c0.4,1.1,0.5,2.4,0.3,3.5c0,0.9,0.4,1.8,1.1,2.5 c0.7,0.7,1.6,1,2.5,1c0.9,0,1.9-0.4,2.5-1c0.7-0.7,1-1.6,1-2.5c-0.2-1.1-0.1-2.3,0.3-3.5c0.4-1.1,1-2.2,1.9-3c1.7-1.3,2.9-3,3.5-4.9 c0.6-2,0.6-4-0.1-6c-0.6-1.9-1.9-3.6-3.5-4.8C22.9,9.9,20.9,9.2,18.8,9.2z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M23.5,29.6h-9.4c-0.3,0-0.5-0.2-0.5-0.5s0.2-0.5,0.5-0.5h9.4c0.3,0,0.5,0.2,0.5,0.5S23.8,29.6,23.5,29.6z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIdea);
export default __webpack_public_path__ + "static/media/idea.2a4c6779.svg";
export { ForwardRef as ReactComponent };